export default __webpack_public_path__ + "static/media/close_blue.8de5645c.svg";